// require('dotenv').config();
export const apiConfig = {
  host: 'https://api.nuveta.com',
  // host: process.env.REACT_APP_HOST,
  // host: 'http://127.0.0.1:8000',
  // apiVersion: process.env.REACT_APP_APIVERSION,
  apiVersion: '/api/v1',
  // aToken: process.env.REACT_APP_ATOKEN,
  aToken: 'oE4G6phEvq1L63RVFk5+poFxDBVhATJUPhoxD7N7o6M',
};

export const appConfig = {
  excludePlanId: [3],
};

export const hostUrl = `${apiConfig.host}${apiConfig.apiVersion}`;

export const sliderConfig = {
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  centerMode: true,
  centerPadding: '90px',
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: false,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        dots: true,
      },
    },
  ],
};

/**
 * Landing-page promos that are fulfilled by hand rather than by the coupon engine.
 *
 * NUVETASNACKS is a 0%-amount coupon: it exists so campaign traffic is identifiable, but it
 * discounts nothing and the snacks are added to the order manually after it comes in. Nothing
 * in the funnel or the order summary can show them, so the storefront has to make the promise
 * on its own — hence the future tense. Say "will be added", never "were added": at the moment
 * the customer reads this, they haven't been.
 */
export const manualPromos = {
  NUVETASNACKS: {
    message: 'Free snacks will be added to your first delivery.',
  },
};

export const findManualPromo = code =>
  manualPromos[String(code || '').toUpperCase()] || null;

/**
 * Reassurance copy for real coupons carried in from a ?coupon= link.
 *
 * The code is only applied at checkout (it needs a subscription to attach to), so until then
 * nothing in the funnel shows the discount and visitors assume the link didn't work. This bar
 * says it's saved. It disappears on its own at checkout, where the pending code is applied and
 * cleared and the order summary takes over showing the discount.
 *
 * 50NOW is limited to one use per customer, so promise the first order only — renewals go back
 * to full price.
 */
export const couponBanners = {
  '50NOW': {
    message:
      '50% off your first order! Your code 50NOW is saved and will be applied at checkout.',
  },
};

export const findCouponBanner = code =>
  couponBanners[String(code || '').toUpperCase()] || null;
